module.exports = __webpack_public_path__ + "img/Badge_BONUS.2f871400.png";